import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import './style.css';
export default function MentionComponent(_ref) {
  var attributes = _ref.attributes,
      children = _ref.children,
      isClickable = _ref.isClickable,
      isFocused = _ref.isFocused,
      userId = _ref.userId;
  return React.createElement("span", Object.assign({
    "data-editor": "mention-".concat(userId),
    className: classNames('entity-highlight', 'padding-horizontal-smaller font-weight-medium ', {
      'pointer is-clickable': isClickable,
      'is-selected': isFocused
    })
  }, attributes), children);
}
MentionComponent.propTypes = {
  isClickable: PropTypes.bool,
  isFocused: PropTypes.bool,
  attributes: PropTypes.object,
  children: PropTypes.any,
  userId: PropTypes.string
};